var _ellipse, _circle, _circle2, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuadrupleCircle = function SvgQuadrupleCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 280,
    height: 280,
    fill: "none",
    role: "presentation"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.5,
    cy: 69.5,
    fill: "#000",
    fillOpacity: 0.1,
    rx: 70.5,
    ry: 69.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 69.5,
    r: 69.5,
    fill: "#000",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 209.5,
    r: 70.5,
    fill: "#000",
    fillOpacity: 0.1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.5,
    cy: 208.5,
    fill: "#000",
    fillOpacity: 0.1,
    rx: 69.5,
    ry: 70.5
  })));
};
export default SvgQuadrupleCircle;